(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initialiseGallery(gallery) {
    if (gallery.dataset.veroulaAutoplay === 'true') return;
    const controls = [...gallery.querySelectorAll('slideshow-controls button[aria-label^="Slide "]')];
    if (controls.length < 2 || reduceMotion.matches) return;

    gallery.dataset.veroulaAutoplay = 'true';
    let pausedUntil = 0;

    const pauseForInteraction = () => { pausedUntil = Date.now() + 10000; };
    gallery.addEventListener('pointerdown', pauseForInteraction, { passive: true });
    gallery.addEventListener('focusin', pauseForInteraction);

    window.setInterval(() => {
      if (document.hidden || Date.now() < pausedUntil || gallery.matches(':hover')) return;
      const current = Math.max(0, controls.findIndex((button) => button.getAttribute('aria-selected') === 'true'));
      controls[(current + 1) % controls.length].click();
    }, 7000);
  }

  function initialiseProductGalleries(scope = document) {
    scope.querySelectorAll('media-gallery slideshow-component').forEach(initialiseGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseProductGalleries());
  } else {
    initialiseProductGalleries();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseProductGalleries(event.target));
})();

